import { InputAdornment } from "@mui/material";
import { TFunction } from "react-i18next";

export function adornments(t: TFunction) {
  return {
    kmPerHour: {
      endAdornment: <InputAdornment position="end">{t("adornments.kmPerHour")}</InputAdornment>,
    },
    kgPerHour: {
      endAdornment: <InputAdornment position="end">{t("adornments.kgPerHour")}</InputAdornment>,
    },
    nm3PerSecond: {
      endAdornment: <InputAdornment position="end">{t("adornments.nm3PerSecond")}</InputAdornment>,
    },
    meter: {
      endAdornment: <InputAdornment position="end">{t("adornments.meter")}</InputAdornment>,
    },
    kelvin: {
      endAdornment: <InputAdornment position="end">{t("adornments.kelvin")}</InputAdornment>,
    },
  };
}
